module.exports = __webpack_public_path__ + "static/img/图层 567.833d37a2.png";